import React, { useContext } from 'react';
import { useWindowSize } from 'react-use';
import ThemeContext, { ASIDE_OPEN_COOLDOWN_MS } from '../../contexts/themeContext';

const WrapperOverlay = () => {
	const { width } = useWindowSize();
	const { asideStatus, setAsideStatus, setLeftMenuStatus, setRightMenuStatus, lastAsideOpenTimeRef } =
		useContext(ThemeContext);

	const handleOverlayClick = () => {
		// Ignore clicks that happen right after aside opened (stops flicker on tablet/touch)
		if (Date.now() - lastAsideOpenTimeRef.current < ASIDE_OPEN_COOLDOWN_MS) return;
		setAsideStatus(false);
		setLeftMenuStatus(false);
		setRightMenuStatus(false);
	};

	if (asideStatus && width < Number(process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE))
		return (
			<div
				role='presentation'
				onClick={handleOverlayClick}
				className='wrapper-overlay'
			/>
		);
	return null;
};

export default WrapperOverlay;
